export const CR_NOTIFICATIONS = {
    CASCADE_WRONG_PASS_ID: "CASCADE_WRONG_PASS_ID",
    START_CASCADE_ID: "START_CASCADE_ID"
};
